import { FormBlock } from '@eastcoal/formily/components/FormBlock'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

import { AuditResultAlert } from '../components/AuditResultAlert.js'

import { businessLicenseSchema } from './businessLicenseSchema'
import { kindSchema } from './kindSchema'
import { otherSchema } from './otherSchema'

export const auditEnterpriseFormSchema: SchemaItem[] = [
  {
    type: 'string',
    name: 'id',
    'x-display': 'hidden'
  },
  {
    type: 'void',
    name: 'auditAlert',
    'x-component': AuditResultAlert
  },
  {
    type: 'void',
    'x-component': FormBlock,
    properties: {
      kindPanel: {
        type: 'void',
        title: '交易意向品类',
        'x-component': FormBlock.Panel,
        'x-component-props': {
          id: 'kindPanel'
        },
        properties: kindSchema
      },
      businessLicensePanel: {
        type: 'void',
        title: '企业信息',
        'x-component': FormBlock.Panel,
        'x-component-props': {
          id: 'businessLicensePanel'
        },
        properties: businessLicenseSchema
      },
      otherInfoPanel: {
        type: 'void',
        title: '其他信息',
        'x-component': FormBlock.Panel,
        'x-component-props': {
          id: 'otherInfoPanel'
        },
        properties: otherSchema
      }
    }
  }
]
